import React from 'react';
import { Save } from 'lucide-react';

export const AlbumForm = ({ formData, setFormData, editingAlbum, uploading, onSubmit, onCoverUpload, onCancel }) => {
  return (
    <div className="bg-gray-800 p-6 rounded-lg border border-purple-500/30">
      <h3 className="text-xl font-bold text-purple-500 mb-4">
        {editingAlbum ? 'Edit Album' : 'Create New Album'}
      </h3>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Album Name *</label>
          <input type="text" value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="e.g., DharmaR Label Night - December 2025" required
            className="w-full bg-gray-700 text-white p-3 rounded border border-gray-600 focus:border-purple-500 focus:outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Party Date *</label>
          <input type="date" value={formData.date}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })} required
            className="w-full bg-gray-700 text-white p-3 rounded border border-gray-600 focus:border-purple-500 focus:outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Description (Optional)</label>
          <textarea value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            placeholder="Describe the party, location, vibe..." rows="3"
            className="w-full bg-gray-700 text-white p-3 rounded border border-gray-600 focus:border-purple-500 focus:outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Cover Image (Optional)</label>
          <div className="flex gap-4 items-start">
            <div className="flex-1">
              <input type="file" accept="image/*" onChange={onCoverUpload}
                className="w-full bg-gray-700 text-white p-2 rounded border border-gray-600" />
              {uploading && <span className="text-purple-500 text-sm">Uploading...</span>}
            </div>
            {formData.cover_image && (
              <img src={formData.cover_image} alt="Cover preview" className="w-20 h-20 object-cover rounded" />
            )}
          </div>
          <p className="text-gray-500 text-xs mt-1">If not set, the first photo will be used as cover.</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Display Order</label>
          <input type="number" value={formData.order}
            onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
            className="w-full bg-gray-700 text-white p-3 rounded border border-gray-600 focus:border-purple-500 focus:outline-none"
          />
        </div>
        <div className="flex gap-2">
          <button type="submit" className="bg-purple-500 text-white px-6 py-2 rounded-lg hover:bg-purple-600 flex items-center gap-2">
            <Save size={20} /> {editingAlbum ? 'Update Album' : 'Create Album'}
          </button>
          <button type="button" onClick={onCancel} className="bg-gray-600 text-white px-6 py-2 rounded-lg hover:bg-gray-700">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};
